export const loginPageObject = () => ({
    googleLoginButton: document.getElementById("signin-google"),
    appleLoginButton: document.getElementById("signin-apple"),
    submitPasswordlessIdButton: document.getElementById("submit-button-enter"),
    submitPasswordlessCodeButton: document.getElementById(
        "passwordless-submit-btn"
    ),
    submitWithPasswordButton: document.getElementById("submit-button"),
    resendCodePasswordlessButton: document.getElementById(
        "passwordless-resend-button"
    ),
    switchFromPasswordlessToPasswordButton:
        document.getElementById("signin-password"),
    forgotPasswordLink: document.getElementById("forgot-password"),
    returnPasswordlessNav: document.getElementById("return-passwordless")
})
